/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Kinzig_Schule2Inputs */

const en__field_enum_kinzig_schule2 = /** @type {(inputs: _Field_Enum_Kinzig_Schule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüchtern`)
};

const de__field_enum_kinzig_schule2 = /** @type {(inputs: _Field_Enum_Kinzig_Schule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinzig-Schule`)
};

/**
* | output |
* | --- |
* | "Schlüchtern" |
*
* @param {_Field_Enum_Kinzig_Schule2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_kinzig_schule2 = /** @type {((inputs?: _Field_Enum_Kinzig_Schule2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Kinzig_Schule2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_kinzig_schule2(inputs)
	return de__field_enum_kinzig_schule2(inputs)
});
export { _field_enum_kinzig_schule2 as "_field_enum_Kinzig_Schule" }